import { useFormatDate } from "hooks/useFormatDate";
import { formatDate } from "utils/dates";

type Props = {
  value: Date | string | null | undefined;
  format?: string;
  withTime?: boolean;
  withSeconds?: boolean;
};

export const FormattedDate = ({
  value,
  format,
  withTime,
  withSeconds,
}: Props) => {
  const { formatDate: formatStandardDate } = useFormatDate();

  let formattedValue: string;
  if (format) {
    formattedValue = formatDate(value, format);
  } else {
    formattedValue = formatStandardDate(value, { withTime, withSeconds });
  }

  if (!formattedValue) {
    return null;
  }

  return <>{formattedValue}</>;
};
